import { Injectable, Inject } from '@angular/core';
import { Observable, of, BehaviorSubject, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as uuid from "uuid";
import * as _ from 'lodash';
import moment from 'moment';
import { FileService } from './file.service';
import { AuthService } from './auth.service';
import { ToastrService } from './toastr.service';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
   providedIn: 'root'
})
export class ReportService {

   className = 'ReportService';
   private _subject: BehaviorSubject<any>;
   observer: Observable<any>;

   constructor(private http: HttpClient, @Inject("environment") private environment: any, private fileService: FileService,
      private authService: AuthService, private toastService: ToastrService, private translateService: TranslateService) {
      this._subject = new BehaviorSubject<any>(null);
      this.observer = this._subject.asObservable();
   }

   comments(data) {
      this._subject.next(data);
   }


   getAllByJobId(jobId) {
      let params = {
         jobId
      }
      let options = {
         params
      }
      return this.http.get(this.environment.base_URL + "/reports", options).pipe(map(res => {
         let reportsMapped = _.map(res, (r) => {
            r = this.prepareRecipients(r);
            return r;
         })
         return reportsMapped;
      }));
   }

   save(report) {
      return this.http.post(this.environment.base_URL + "/reports", report);
   }

   update(report) {
      return this.http.put(this.environment.base_URL + `/reports/${_.get(report, 'idReportPk')}`, report);
   }

   generate(report, type) {
      let reportCopy = _.cloneDeep(report);
      _.forEach(_.get(reportCopy, 'sections'), (s) => {
         s.description = s.description || "-";
         delete s['form'];
      })
      _.forEach(_.get(reportCopy, 'facts'), (s) => { // 046921
        s.form = s.form || "-";
        delete s['form'];
        _.forEach(_.get(s, 'recommendations'), (s) => {
          s.form = s.form || "-"
          delete s['form'];
        })
      })
      let key = `${uuid.v4()}/${_.get(report, 'name')}${type === "PDF" ? ".pdf" : ".doc"}`;
      let audiweb = 'true';
      let params = {
         type,
         key,
         audiweb
      }
      let options = {
         params
      }
      //046921 ERROR DESCARGA INFORMES RESUELTA
      return this.http.post(this.environment.base_URL + `/reports/${_.get(report, 'idReportPk')}/generate`, reportCopy, options)
         .pipe(mergeMap((res: any) => {
            let options = {
               responseType: "blob" as 'json'
            }
            return this.http.get(res, options);
         }));
   }

   getSnapshot(report, type) {
      let key = `${uuid.v4()}/${_.get(report, 'name')}.pdf`;
      return this.fileService.download(key, type, _.get(report, 'idReportPk'), _.get(report, 'typeDocument'));
   }

   emit(reportId) {
      return this.http.post(this.environment.base_URL + `/reports/${reportId}/emit`, null);
   }

   redistribute(body) {
      return this.http.post(this.environment.base_URL + `/reports/redistribute`, body);
   }

   getFilteredReports(params): Observable<any[]> {
      return this.http.get<any[]>(this.environment.base_URL + "/reports/audited", { params }).pipe(map((res: any) => {
         let reportsMapped = _.map(res.content, (r) => {
            //todo prepare recommendations
            r = this.prepareRecommendations(r);
            r = this.prepareRecipients(r);
            return r;
         })
         res.content = reportsMapped;
         return res;
      }));
   }

   getAllAudited(version, dashboard) {
      let options = {
         params: {
            version,
            dashboard
         }
      }

      //return of(AUDITED_REPORTS)
      return this.http.get(this.environment.base_URL + "/reports/audited", options).pipe(map(res => {
         let reportsMapped = _.map(res, (r) => {
            //todo prepare recommendations
            r = this.prepareRecommendations(r);
            r = this.prepareRecipients(r);
            return r;
         })
         return reportsMapped;
      }));
   }

   exportReport(key, params) {
      _.set(params, "key", key + '/data.json');

      // Call aws gateway to generate pre signed url
      return this.http.get<any[]>(this.environment.base_URL + "/exported-url", { params })
         .pipe(mergeMap((res: any) => {

            // Remove key paramenter and add url parameter
            _.unset(params, "key")
            _.set(params, "url", res)

            // Call Mapgre Gateway to generate excel with exoprted jobs
            return this.http.get<any[]>(this.environment.base_URL + "/exported-reports", { params })
               .pipe(mergeMap((res: any) => {

                  // Remove url paramenter and add key parameter
                  let paramsExcel = {}
                  _.set(paramsExcel, "keydata", key + '/data.json');
                  _.set(paramsExcel, "keyexcel", key + '/export.xlsx');

                  return this.http.get<any[]>(this.environment.base_URL + "/create-excel", { params: paramsExcel })
                     .pipe(mergeMap((res3: any) => {

                        // Remove url paramenter and add key parameter
                        let paramsDownload = {}
                        _.set(paramsDownload, "key", key + '/export.xlsx')
                        _.set(paramsDownload, "onlyDownload", true)


                        // Download excel
                        return this.http.post(this.environment.base_URL + `/download`, null, { params: paramsDownload })
                           .pipe(mergeMap((res: any) => {

                              // Download file
                              let options = {
                                 responseType: "blob" as 'json'
                              }

                              // Download file form S3
                              return this.http.get(res, options);

                           }), map(res => {

                              // Delete file when downloaded
                              this.delete(key).subscribe(() => { });
                              return res;

                           }), catchError(err => {
                              this.toastService.add({
                                 severity: "error",
                                 summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                                 detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
                              });
                              return throwError(err);
                           }))
                     }))
               }))

         }), map(res => {
            return res;
         }), catchError(err => {
            this.toastService.add({
               severity: "error",
               summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
               detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
            });
            return throwError(err);
         }))

   }

   delete(key): any {
      let params = {
         key
      }
      return this.http.post(this.environment.base_URL + "/delete", { params }).pipe(catchError(err => {
         this.toastService.add({
            severity: "error",
            summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
            detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
         });
         return throwError(err);
      }));
   }

   getAllAuditedPending(fromDays = 15) {
      return this.getAllAudited(1, true).pipe(map((reports: any) => {
         return _.filter(reports, r => {
            let daysFromEmit = moment().diff(moment(_.get(r, 'issueDate')), 'days');
            return daysFromEmit <= fromDays && r.hasPendingActions
         })
      }))
   }

   prepareRecipients(report) {
      _.forEach(_.get(report, 'recipients'), recipient => {
         let name = _.get(recipient, 'txtName', "");
         let lastName1 = _.get(recipient, 'txtLastname1', "") ? ` ${_.get(recipient, 'txtLastname1', "")}` : "";
         let lastName2 = _.get(recipient, 'txtLastname2', "") ? ` ${_.get(recipient, 'txtLastname2', "")}` : "";
         _.set(recipient, 'fullName', `${name}${lastName1}${lastName2}`);
      })
      return report
   }

   prepareRecommendations(report) {
      let allRecommendationsCriticality = _.reduce(_.get(report, 'facts'), (prev, fact) => {
         prev = _.reduce(_.get(fact, 'recommendation'), (rPrev, r) => {
            let criticalityKey = _.get(r, 'typeCritique.txtTypeCritiqueFact');
            _.set(rPrev, criticalityKey, _.get(rPrev, criticalityKey, 0) + 1);
            return rPrev;
         }, prev);
         return prev;
      }, {})
      report = _.set(report, 'recommendations', allRecommendationsCriticality);
      return report;
   }

   review(report) {
      return this.http.post(this.environment.base_URL + "/reports/review", _.pick(report, 'idReportPk'));
   }

   read(report) {
      return this.http.post(this.environment.base_URL + "/reports/read", _.pick(report, 'idReportPk'));
   }

   getById(reportId) {
      return this.http.get(this.environment.base_URL + `/reports/${reportId}`);
   }

   comment(commentObj) {
      return this.http.post(this.environment.base_URL + "/reports/comment", commentObj);
   }
}
